import { ProjectEnvironmentTypePermissionRecord, ProjectPermissionRecord } from '../../models/permission';
import { createStringIdAdapter } from './common/string-id-adapter';

export const projectEnvironmentTypePermissionRecordAdapter =
    createStringIdAdapter<ProjectEnvironmentTypePermissionRecord>();

export const projectPermissionRecordAdapter = createStringIdAdapter<ProjectPermissionRecord>();
